import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { UseMutationsParams, AlertSeverityEnum, NapsQGIS, INapsQGISPagingRes } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';
import { INapsPagingRes, Naps } from '@/shared/interfaces/erp/mantenimiento-operaciones';

const { get, post, put } = erpApi();

///* tanSctack query

export const useFetchNaps = ({
  enabled = true,
  page = 1,
  page_size = 10,
  nombre = '',
  ciudad = '',
  coordernadas,
  ...rest
}: GetNapsParams) => {
  return useQuery({
    enabled: enabled,
    queryKey: ['naps', {page, nombre, ciudad, coordernadas, page_size, ...rest}], // Include ciudad in the query key
    queryFn: async () => {
      return getNaps({ page, nombre, ciudad, coordernadas, page_size, ...rest }); // Pass ciudad to getNaps
    },
  });
};
export const useGetnap = (id: string) => {
  return useQuery({
    queryKey: ['naps', id],
    queryFn: async () => {
      return getnap(id);
    },
  });
};

export const useCreateNaps = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: createNaps,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['naps'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Nap creada correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const useUpdateNaps = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: updateNaps,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['naps'] });
      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Nap actualizada correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

///* axios
export interface GetNapsParams extends Partial<Naps> {
  enabled?: boolean;
  page?: number;
  page_size?: number;
  nombre?: string;
  lat?: string;
  lng?: string;
  coordernadas?: string;

  //ciudad?: string;
};

export type CreateNapsParams = Omit<Naps, 'id_nap'>;
export type UpdateNapsParams = {
  id: string;
  data: Partial<CreateNapsParams>;
};

export const getNaps = async (params?: GetNapsParams) => {
  const queryParams = getUrlParamsFetch({ ...params });
  return get<INapsPagingRes>(
    `${urlBackend}api/v1/nap/?${queryParams}`,
    true
  );
};

export const getnap = async (id: string) => {
  try {
    return await get<Naps>(`${urlBackend}api/v1/nap/${id}/`, true);
  }
  catch (error) {
    handleAxiosError(error);
  }
};

export const createNaps = async (data: CreateNapsParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await post<Naps>(`${urlBackend}api/v1/nap/`, data, true);

  setAlert(true, res.message, res.status);
  return res;
};

export const updateNaps = async ({ id, data }: UpdateNapsParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await put<Naps>(`${urlBackend}api/v1/nap/${id}/`, data, true);
  setAlert(true, res.message, res.status);
  return res;
};

//NAPS DE QGIS PARA REVISIÓN DE ESTADO

export interface GetNapsQGISParams extends Partial<NapsQGIS> {
  enabled?: boolean;
  page?: number;
  page_size?: number;
  nombre?: string;
  lat?: string;
  lng?: string;
  coordernadas?: string;
};

export const useFetchNapsQGIS = ({
  enabled = true,
  page = 1,
  page_size = 10,
  nombre = '',
  ciudad = '',
  coordernadas,
  ...rest
}: GetNapsQGISParams) => {
  return useQuery({
    enabled: enabled,
    queryKey: ['naps-qgis', { page, page_size, nombre, ciudad, coordernadas, ...rest }],
    queryFn: async () => {
      return getNapsQGIS({ page, nombre, page_size, ciudad, coordernadas, ...rest });
    },
  });
};

export const getNapsQGIS = async (params?: GetNapsQGISParams) => {
  console.log("params", params);
  const queryParams = getUrlParamsFetch({ ...params });
  console.log("queryParams", queryParams);
  return get<INapsQGISPagingRes>(
    `${urlBackend}api/v1/naps-qgis/?${queryParams}`,
    true
  );
};